import { FC, Fragment, useEffect, useRef } from "react";
import useAppSelector from "hooks/useAppSelector";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { store } from "store";
import { authLogout } from "store/auth";
import useAppPermission from "hooks/useAppPermission";
import { apiAuthCheck } from "apis";
import AppLoading from "components/AppLoading";


interface AdminContainerProps {
}

const menus = [
  {
    label: "Tổng quan",
    iconClass: "fa fa-solid fa-chart-column",
    url: "/administrator",
    permissionCode: null
  },
  {
    label: "Giới thiệu",
    iconClass: "fa-solid fa-circle-info",
    url: "/administrator/about.html",
    permissionCode: "admin.about"
  },
  {
    label: "Tầm nhìn sứ mệnh",
    iconClass: "fa-solid fa-circle-info",
    url: "/administrator/mission-vision.html",
    permissionCode: "admin.about"
  },
  {
    label: "Phòng ban",
    iconClass: "fa-solid fa-people-roof",
    url: "/administrator/department.html",
    permissionCode: "admin.department"
  },
  {
    label: "Chức danh",
    iconClass: "fa-solid fa-id-card-clip",
    url: "/administrator/position.html",
    permissionCode: "admin.position"
  },
  {
    label: "Vai trò",
    iconClass: "fa-solid fa-chart-simple",
    url: "/administrator/role.html",
    permissionCode: "admin.role"
  },
  {
    label: "Chuyên khoa",
    iconClass: "fa-solid fa-hospital-user",
    url: "/administrator/specialty.html",
    permissionCode: "admin.specialty"
  },
  {
    label: "Quyền",
    iconClass: "fa-solid fa-folder-tree",
    url: "/administrator/permission.html",
    permissionCode: "admin.permission"
  },
  {
    label: "Người dùng",
    iconClass: "fa-solid fa-user-doctor",
    url: "/administrator/user.html",
    permissionCode: "admin.user"
  },
  {
    label: "Chủ đề",
    iconClass: "fa-solid fa-file-circle-check",
    url: "/administrator/topic.html",
    permissionCode: "admin.topic"
  },
  {
    label: "Bài viết",
    iconClass: "fa-solid fa-newspaper",
    url: "/administrator/post.html",
    permissionCode: "admin.post"
  },
  {
    label: "Dịch vụ",
    iconClass: "fa-solid fa-chart-simple",
    url: "/administrator/service.html",
    permissionCode: "admin.service"
  },
  {
    label: "Tin nhắn",
    iconClass: "fa-solid fa-message",
    url: "/administrator/message.html",
    permissionCode: "admin.service"
  },
  {
    label: "Khung giờ",
    iconClass: "fa-solid fa-clock",
    url: "/administrator/time-frame.html",
    permissionCode: "admin.time-frame"
  },
  {
    label: "Đặt hẹn",
    iconClass: "fa-solid fa-calendar-check",
    url: "/administrator/booking.html",
    permissionCode: "admin.booking"
  },
  {
    label: "Thông báo",
    iconClass: "fa-solid fa-bell",
    url: "/administrator/notification.html",
    permissionCode: "admin.notification"
  },
  {
    label: "Thư viện",
    iconClass: "fa-solid fa-folder-open",
    url: "/administrator/library.html",
    permissionCode: "admin.config"
  },
  {
    label: "Cấu hình",
    iconClass: "fa-solid fa-gear",
    url: "/administrator/config.html",
    permissionCode: "admin.config"
  }
];

const AdminContainer: FC<AdminContainerProps> = ({
}) => {

  useEffect(() => {
    apiAuthCheck();
  }, [])

  const { pathname } = useLocation();
  const auth = useAppSelector((state) => state.auth);
  const config = useAppSelector((state) => state.config);
  const { allow } = useAppPermission();
  if (!auth.checked) {
    return <AppLoading />
  }
  return (
    <Fragment>
      {/* {isLoginPage && !auth.invalid && <Navigate to="/administrator" replace />} */}
      {auth.invalid && (
        <Navigate to="/administrator/login.html" replace />
      )}
      <div className="bg-gray-100 flex min-h-screen">
        <aside className="w-80 bg-white shadow-lg h-screen fixed top-0 left-0 flex flex-col">
          <Link className="flex items-center space-x-3 border-b border-gray-200 p-2" to="/administrator/profile.html">
            {/* Avatar */}
            <img
              src={auth.user?.avatarUrl}
              alt={auth.user?.lastName}
              className="w-10 h-10 rounded-full border border-gray-300 object-cover overfllow-hidden"
            />

            {/* Thông tin */}
            <div className="flex flex-col">
              <span className="font-semibold text-gray-800">{auth.user?.firstName} {auth.user?.lastName}</span>
              <span className="text-sm text-gray-500">{auth.user?.role?.name}</span>
            </div>
          </Link>
          <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
            {
              menus
                .filter(menu => !menu.permissionCode || allow(menu.permissionCode))
                .map((menu, i) => {
                  const isActive = pathname.replace(/\.html$/, "") === menu.url.replace(/\.html$/, "");
                  return <Link
                    key={i}
                    to={menu.url}
                    className={`block px-4 py-2 rounded text-gray-800 transition-colors ${isActive
                      ? "bg-blue-500 text-white"
                      : "hover:bg-blue-100"
                      }`}
                  >
                    <span className="inline-block w-7">
                      <i className={menu.iconClass}></i>
                    </span>
                    {menu.label}
                  </Link>
                })
            }
          </nav>
          <div className="p-4 border-t border-gray-200">
            <button className="w-full bg-red-100 text-red-700 py-2 rounded hover:bg-red-200" onClick={() => store.dispatch(authLogout())}>
              Đăng xuất
            </button>
          </div>
        </aside>
        <Outlet />
        {/* <Notification /> */}
      </div>
    </Fragment>
  );
};
export default AdminContainer;
